import React from 'react';
import { Typo, Rhythm } from 'components/Layout';
import { Button } from 'components/Form';
import Icon from 'components/Icon';
import { Spinner } from 'components/Spinner';

import styles from './styles.css';

export default ({ state, hideModal }: any) => (
  <div className={styles.root}>
    <Spinner />
    {state.title && (
      <Typo.Title className={styles.title}>{state.title}</Typo.Title>
    )}
    {state.description && (
      <Typo.Paragraph className={styles.description}>
        {state.description}
      </Typo.Paragraph>
    )}
  </div>
);
